// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"987be27d","247":"5b7348eb","284":"ea93e8f2","350":"9a5ad3b8","453":"cea4e896","467":"a3d304c2","514":"08ef258c","517":"ed297b4a","618":"de219937","627":"5cbece00","728":"12c2b2a3","854":"2f63d312","855":"9c11066f","867":"a53db872","923":"efd379cc","938":"4f354ce2"}[chunkId] + ".chunk.js";
};